import { DEFAULT_SELECTED_NETWORK_ID } from './DEFAULT_SELECTED_NETWORK_ID';
import { NetworkValue } from './NETWORK_NAMES.types';
import { NETWORK_OPTION_BY_SUPPORTED_ID } from './NETWORK_OPTIONS';

export const DEFAULT_NETWORK_VALUE: Readonly<NetworkValue> =
  NETWORK_OPTION_BY_SUPPORTED_ID[DEFAULT_SELECTED_NETWORK_ID].value;
